import React from "react";

const NominationSelection = ({ 
  nominations, 
  loading, 
  onNominationSelect, 
  onJudgesSelect, 
  onSwitchToSingle,
  onSwitchToQuad,
  isQuadMode,
  t 
}) => {
  if (loading) {
    return (
      <div className="nomination-selection-loading">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t.loading}</span>
          </div>
          <p className="mt-3 text-muted">{t.loading}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="nomination-selection">
      <div className="container-fluid h-100 p-4" style={{ overflowY: 'auto' }}>
        <div className="text-center mb-4">
          <h3 className="nomination-selection-title fw-bold text-primary">
            {t.nomination_selection_title}
          </h3>
        </div>
        
        <div className="row g-3 justify-content-center">
          {nominations.map((nomination) => (
            <div key={nomination.id} className="col-auto">
              <div 
                className="card nomination-card shadow-sm border-0 h-100"
                onClick={() => onNominationSelect(nomination.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && onNominationSelect(nomination.id)}
              >
                <div className="card-body text-center">
                  <div className="nomination-icon-wrapper mb-3">
                    <i className="fa-solid fa-trophy nomination-icon text-warning"></i>
                  </div>
                  <h6 className="card-title fw-bold mb-2">{nomination.title}</h6>
                  <span className="badge bg-primary rounded-pill">
                    Номинация
                  </span>
                </div>
              </div>
            </div>
          ))}
          
          {/* Judges card */}
          {/*
          <div className="col-auto">
            <div 
              className="card nomination-card judges-card shadow-sm border-0 h-100"
              onClick={onJudgesSelect}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && onJudgesSelect()}
            >
              <div className="card-body text-center">
                <div className="nomination-icon-wrapper mb-3">
                  <i className="fa-solid fa-users nomination-icon text-info"></i>
                </div>
                <h6 className="card-title fw-bold mb-2">{t.judges}</h6>
                <span className="badge bg-info rounded-pill">
                  Судейский состав
                </span>
              </div>
            </div>
          </div>
          */}
        </div>
        
        {/* Screen mode switch */}
        <div className="text-center mt-4">
          <div className="screen-mode-switch">
            {isQuadMode ? (
              <button
                className="btn btn-outline-success btn-lg screen-switch-btn shadow-sm"
                onClick={onSwitchToSingle}
              >
                <i className="fa-solid fa-desktop me-2"></i>
                {t.switch_to_single_screen}
              </button>
            ) : (
              <button
                className="btn btn-outline-secondary btn-lg screen-switch-btn shadow-sm"
                onClick={onSwitchToQuad}
              >
                <i className="fa-solid fa-th-large me-2"></i>
                {t.switch_to_quad_screen}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NominationSelection;